export default{
  language: {
    name: 'EN'
  },
  navbar: {
    About:'关于我们',
    CompanyProfile:'公司简介',
    CompanyNews:'公司动态',
    ContactUs:'联系我们',
    JoinUs:'加入我们',
    Solution:'解决方案',
    Industrial: '工业解决方案',
    Academic: '学术教育方案',
    product:'产品',
    FunctionIntroduce:'功能介绍',
    ProformanceTest:'性能测试',
    Mcloudlogin: '超算云Mcloud入口',
    Download:'下载',
    SoftWareDownload:'PWmat',
    PotentialDownload:'赝势文件',
    Paper:'论文',
    Course:'资源中心',
    Document:'文档',
    video:'视频',
    ApplyTest:'申请测试',
    more:'更多',
    Log:'更新日志',
    Forum:'论坛',







  },
  footer:{
    DeveloplerCenter:'开发者中心',
    Tutorials:'教程',
    Documentation:'文档',
    Bounty:'悬赏',
    SmartX:'SmartX',
    Github:'Github',
    Cooperation:'合作',
    CooperateWithOntology:'与本体合作',
    TrustEcosystem:'信任生态',
    Nodes:'节点',
    About:'关于',
    Press:'新闻',
    TechNews:'本体视点',
    Team:'团队',
    AboutOntology:'关于本体',
    WhitePaper:'White Paper',
    Explorer:'区块链浏览器',
    dApps:'dApps',
    dAppsList:'dApps列表',
    SubmitAdApp:'提交dApp',
  }
}
